import { render, staticRenderFns } from "./merchantAddStore.vue?vue&type=template&id=8d047cfc"
import script from "./merchantAddStore.vue?vue&type=script&lang=js"
export * from "./merchantAddStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports